export const ARIA_LIVE_MESSAGE_ANNOUNCE_TIME_IN_MS = 1000;
